"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.search.placeholder': 'Szukaj płatności po ID sesji, opisie, emailu...',
};
